import { DataEvent } from "@fanfanlo";
import { Permission } from "./Permission";


export class PermissionEvent extends DataEvent<any>{
    bl:boolean|undefined
    extra:any
    permission!:Permission
    constructor(type:any, bl:boolean|undefined, extra:any, permission:Permission) {
        super(type, {bl, extra, permission});
        this.bl = bl;
        this.extra = extra
        this.permission = permission
    }

}